var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-group.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0697 7.36661C11.4757 6.67467 11.6511 5.87149 11.5704 5.07328C11.451 3.88395 10.787 2.83261 9.70171 2.11328L8.96504 3.22395C9.71104 3.71861 10.165 4.42328 10.2437 5.20661C10.28 5.57068 10.2347 5.93825 10.111 6.2826C9.98741 6.62695 9.78859 6.93942 9.52904 7.19728L8.73438 7.99195L9.81304 8.30861C12.6344 9.13528 12.667 11.9726 12.667 12.0013H14.0004C14.0004 10.8086 13.363 8.47795 11.0697 7.36661Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.33398 8.0013C7.80465 8.0013 9.00065 6.8053 9.00065 5.33464C9.00065 3.86397 7.80465 2.66797 6.33398 2.66797C4.86332 2.66797 3.66732 3.86397 3.66732 5.33464C3.66732 6.8053 4.86332 8.0013 6.33398 8.0013ZM6.33398 4.0013C7.06932 4.0013 7.66732 4.5993 7.66732 5.33464C7.66732 6.06997 7.06932 6.66797 6.33398 6.66797C5.59865 6.66797 5.00065 6.06997 5.00065 5.33464C5.00065 4.5993 5.59865 4.0013 6.33398 4.0013ZM7.33398 8.66797H5.33398C3.12798 8.66797 1.33398 10.462 1.33398 12.668V13.3346H2.66732V12.668C2.66732 11.1973 3.86332 10.0013 5.33398 10.0013H7.33398C8.80465 10.0013 10.0007 11.1973 10.0007 12.668V13.3346H11.334V12.668C11.334 10.462 9.53998 8.66797 7.33398 8.66797Z",
    fill: "#767676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxGroup);
export default __webpack_public_path__ + "static/media/bx-group.77d21f3420a06f82555eb5765d1918fb.svg";
export { ForwardRef as ReactComponent };